export default "__VITE_ASSET__376b0c87__"